import { baseSplitApi } from './baseApi';

const clientAuthPath = "/auth/client"
const employeeAuthPath = "/auth/employee"

export const userAuthApi = baseSplitApi.injectEndpoints({
  endpoints: (build) => ({
    userLogin: build.mutation({
      query: (credentialData) => {
        return {
          url: `${clientAuthPath}/login`,
          method: 'POST',
          body: credentialData
        }
      },
    }),
    userLogout: build.mutation({
      query: (data) => {
        return {
          url: `${clientAuthPath}/logout`,
          method: 'POST',
          body: data
        }
      }
    }),
    resetPasswordEmail: build.mutation({
      query: (data) => {
        return {
          url: `${clientAuthPath}/generate_password_reset_req`,
          method: 'POST',
          body: data
        }
      }
    }),
    resetPassword: build.mutation({
      query: ({ tokenId, userId, body }) => {
        return {
          url: `${clientAuthPath}/password_reset?tokenId=${tokenId}&clientId=${userId}`,
          method: 'POST',
          body: body
        }
      }
    }),
    loginJCRUser: build.mutation({
      query: (body) => {
        return {
          url: `${employeeAuthPath}/login`,
          method: 'POST',
          body: body
        }
      }
    }),
    verifyJCRUserOTP: build.mutation({
      query: (body) => {
        return {
          url: `${employeeAuthPath}/verify_otp`,
          method: 'POST',
          body: body
        }
      }
    }),

    getAllEmployee: build.query({
      query: (queryParams) => {
        return {
          url: `${employeeAuthPath}?${queryParams}`,
          method: "GET"
        }
      },
      transformResponse: (response) => response.map(emp => {
        let dropDownOptions = ({ value: emp._id, label: `${emp.firstName} ${emp.lastName}` })
        if (emp.outlookAuthRef === null) {
          dropDownOptions.label += " (No outlook record found)"
          dropDownOptions = ({ ...dropDownOptions, disabled: true })
        }
        return dropDownOptions
      })
    })

  }),
  overrideExisting: false,
})

// These hooks gets auto generated based on endpoints
export const {
  useUserLoginMutation, useUserLogoutMutation, useResetPasswordEmailMutation, useResetPasswordMutation,
  //ops specific
  useLoginJCRUserMutation, useVerifyJCRUserOTPMutation, useGetAllEmployeeQuery
} = userAuthApi;